import React, { useEffect, useState, useCallback } from 'react';
import { ButtonCreateEvent } from './components/ButtonCreateEvent';
import styles from './ListEvent.module.scss';
import { TableListEvent } from './components/TableListEvent';
import { useDispatch } from 'react-redux';
import {
  createEvent,
  getListEvent,
  loadEventDictionaries,
  updateEvent,
} from '../../../../redux/asyncActions/listEvent';
import { loadOrganizationTypes } from '../../../../redux/asyncActions/dictionaries';
import { ModalEvent } from './components/ModalEvent';

export const ListEvent = () => {
  const dispatch = useDispatch();
  const [mode, setMode] = useState(null);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    dispatch(getListEvent());
    dispatch(loadOrganizationTypes());
    dispatch(loadEventDictionaries());
  }, [dispatch]);

  const openCreate = useCallback(() => {
    setCurrent(null);
    setMode('create');
  }, []);

  const openEdit = useCallback((service) => {
    setCurrent(service);
    setMode('edit');
  }, []);

  const close = useCallback(() => setMode(null), []);

  const handleSubmit = useCallback(
    ({ mode, values }) => {
      if (mode === 'create') {
        dispatch(createEvent(values));
      } else {
        dispatch(updateEvent(values));
      }
    },
    [dispatch]
  );

  return (
    <div>
      <div className={styles.containerButtonCreateEvent}>
        <ButtonCreateEvent openCreate={openCreate} />
      </div>
      <TableListEvent onEdit={openEdit} />
      <ModalEvent
        mode={mode}
        open={!!mode}
        initialValues={current}
        onCancel={close}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
